<!-- BOM管理 生产配置-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :inline="true" class="demo-form-inline" :model="searchForm" size="small" :ref="searchForm">
          <el-form-item label="产品名称：">
            <el-input size="medium" placeholder="名称" minlength="2" maxlength="10" v-model="searchForm.NAME" clearable></el-input>
          </el-form-item>
          <el-form-item label="生产部门：">
            <el-select size="medium" filterable v-model="searchForm.department" style="width: 100%" :clearable="true">
              <el-option v-for="item in departmentList" :key="item.ID" :value="item.ID" :label="item.DEPARTMENT_NAME">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="handleCurrentChange(1)">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" @click="openAdd">新增原材料</el-button>
        <el-button size="medium" @click="exportProduction">批量导入</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border style="margin-top: 20px" :data="tableData">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column prop="CP_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="NAME" label="产品名称"></el-table-column>
          <el-table-column prop="ALIAS_NAME" label="产品别名"></el-table-column>
          <el-table-column prop="DEPARTMENT_NAME" label="部门"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="openEdit(scope.row)" type="text">修改</el-button>
              <el-button @click="openDetail(scope.row)" type="text">查看生产配置</el-button>
              <el-button @click="deleteRecord(scope.row)" type="text" style="color: red">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount" style="float: right"></el-pagination>
      </el-col>
    </el-row>
    <!-- 修改 -->
    <el-dialog title="修改" :visible.sync="editFormVisible" width="30%" center>
      <el-form :ref="editForm" :model="editForm" label-width="100px" style="text-align: inherit;margin: 0">
        <el-form-item label="产品别名：">
          <el-input v-model="editForm.ALIAS_NAME"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button @click="submitEdit('editForm')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导入生产配置 -->
    <el-row>
      <el-col>
        <el-dialog title="导入生产配置" center :visible.sync="exportVisible" width="400px">
          <el-form size="small" :model="exportForm" ref="exportForm">
            <el-form-item label="生产部门：" label-width="100px">
              <el-select filterable v-model="exportForm.department" style="width: 100%">
                <el-option v-for="item in departmentList" :key="item.ID" :value="item.ID" :label="item.DEPARTMENT_NAME">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择文件：" label-width="100px">
              <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-remove="handleRemove"
                :on-success="handleSuccess" :name="this.exportForm.name" multiple :limit="1" accept=".xls,.xlsx"
                :file-list="fileList">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
              </el-upload>
              <p @click="downLoadOrder" style="color: #409EFF;margin-top: 20px;cursor: pointer">点击下载导入模板</p>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="exportVisible = false">取 消</el-button>
            <el-button size="small" @click="submitExport">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  productionSettingFun, deleteFun, editFun, exportProductionFun,
} from 'api/production';
import { queryDepartment } from 'api/productDepart';

export default {
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 15,
      totalCount: 0,
      searchForm: {},
      editFormVisible: false,
      editForm: {},
      exportVisible: false,
      fileList: [],
      file_name: '',
      exportForm: {
        name: 'tmp',
      },
      departmentList: [],
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (JSON.stringify(this.SAVE_PRODOCTION_LIST) != '{}' && this.SAVE_PRODOCTION_LIST != 'undefined') {
      this.searchForm = this.SAVE_PRODOCTION_LIST.CONDITION;
      this.currentPage = this.SAVE_PRODOCTION_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryData();
    this.queryDepartment();
    sessionStorage.removeItem('productArr');
  },
  computed: {
    SAVE_PRODOCTION_LIST() {
      return this.$store.state.PRODUCTION_LIST;
    },
  },
  methods: {
    queryData() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.NAME) {
        params.PRODUCT_NAME = this.searchForm.NAME;
      }
      if (this.searchForm.department) {
        params.DEPARTMENT_ID = this.searchForm.department;
      }
      productionSettingFun(params).then((result) => {
        if (result[0]) {
          this.tableData = result[0].LIST;
          this.totalCount = result[0].TOTAL_COUNT;
          this.$store.dispatch('SET_PRODUCTION_LIST', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.tableData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    openAdd() {
      this.$router.push({ name: 'addProduction' });
    },
    openDetail(row) {
      this.$router.push({ name: 'productionDetail' });
      sessionStorage.setItem('PPL_ID', row.ID);
    },
    deleteRecord(row) {
      const params = {
        PPL_ID: row.ID,
      };
      deleteFun(params).then((result) => {
        this.$message.show({ text: '删除成功', type: 'success' });
        this.queryData(0);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openEdit(row) {
      this.editFormVisible = true;
      this.editForm = row;
    },
    submitEdit() {
      const params = {
        PP_ID: this.editForm.ID,
        ALIAS_NAME: this.editForm.ALIAS_NAME,
      };
      editFun(params).then((result) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.editFormVisible = false;
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    exportProduction() {
      this.exportVisible = true;
    },
    handleSuccess(response, file, fileList) {
      this.file_name = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.file_name = '';
    },
    submitExport() {
      const params = {
        FILE_NAME: this.file_name,
        DEPARTMENT_ID: this.exportForm.department,
      };
      if (!this.exportForm.department || !this.file_name) {
        this.$message.show({ text: '请选择生产部门并上传文件', type: 'warning' });
        return false;
      }
      exportProductionFun(params)
        .then((result) => {
          if (result[0].FILE_PATH == '') {
            this.$message.show({ text: '导入成功', type: 'success' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
            this.exportVisible = false;
          } else {
            this.$message.show({ text: '导入失败，失败原因查看EXCEL', type: 'error' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.file_name = '';
          this.$refs.upload.clearFiles();
        });
    },
    downLoadOrder() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/smpProduceProportioningTemp.xlsx';
    },
    queryDepartment() {
      queryDepartment().then((res) => {
        this.departmentList = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/productionProcessing/productionSet.vue